module.exports = new __parcel__URL__("half-life.88409114.jpg").toString();